import { Component, OnInit, ViewChild } from '@angular/core';
import { TestResultsDataForm } from '../../_models/test-results-data-form';
import { QuestionAnswer } from '../../_models/question-answer';
import { UserSessionDataForm } from '../../_models/login/user-session-data-form';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { SpinnerService } from '../../_core/spinner/spinner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionAnswerService } from '../../_services/question-answer.service';
import { TestResultsService } from '../../_services/test-results.service';
import { MatRadioChange } from '@angular/material';
import { ValidationErrorMessageEnum } from '../../constants/ValidationErrorMessageEnum';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { MatStepperModule} from '@angular/material';
import { NavbarComponent } from '../../navbar/navbar.component';
import { NavbarService } from '../../_services/navbar.service';
import { INavMenu } from '../../navbar/navbar.component';
import { SuccessDialogService } from '../../_services/success-dialog.service';
import { SuccessDialogQuizService } from '../../_services/success-dialog-quiz.service';

@Component({
  selector: 'app-test-basics',
  templateUrl: './test-basics.component.html',
  styleUrls: ['./test-basics.component.css']
})
export class TestBasicsComponent implements OnInit {
  @ViewChild('stepper') stepper;
  navItemSelected: string = '';

  navMenu: INavMenu[] = [];
  questionAnswerList: QuestionAnswer[] = [];
  questionAnswer: QuestionAnswer = new QuestionAnswer();
  userSessionDataForm: UserSessionDataForm = new UserSessionDataForm();
  basicOfQuestionAnswerFormGroup: FormGroup;
  userTestDataForm: QuestionAnswer = new QuestionAnswer();
  finalScore = 0;
  questionAnswerArray;
  answerForLocal;
  hideAnswer = false;
  hideScore = false;
  hideTestDiv = false;
  selectedOption: string;
  totalQuestions = 0;
  
  constructor(
    private authService: AuthService,
    public  spinnerService: SpinnerService,
    private snotifyService: SnotifyService,
    private formbuilder: FormBuilder,
    private router: Router,
    private questionAnswerService: QuestionAnswerService,
    private activatedRoute: ActivatedRoute,
    private testResultsService: TestResultsService,
    private navbarService: NavbarService,
    private successDialogService: SuccessDialogQuizService,

  ) {
  }

  ngOnInit() {
    this.navMenu = this.navbarService.getNavMenu();
    this.getBasicOfPatentQuestions();
    this.userTestValidation();
    this.displayAnswerOnSelected();
    this.hideTestDiv = true;
  }

  userTestValidation() {
    this.basicOfQuestionAnswerFormGroup = this.formbuilder.group({
      'questionAnswers': new FormControl('', [
        //  Validators.compose([
        //  Validators.required])
      ]),
    });
  }



  getBasicOfPatentQuestions() {
    this.questionAnswerService.getBasicOfPatentList().subscribe(
      resp => {
        this.questionAnswerList = resp as QuestionAnswer[];
        const answerForLocal :any[] = [];
        
        this.questionAnswerList.forEach(answer => {
        answerForLocal.push(answer.answer);

        this.totalQuestions = this.questionAnswerList.length;
       
      localStorage.setItem('currentOption', JSON.stringify(answerForLocal));
       });

      const currentOption = localStorage.getItem('currentOption');
       this.questionAnswerArray = JSON.parse(currentOption);
       
        
      }, error => {
        console.log(error);
      });
  }

  optionOne(event: MatRadioChange) {
    let optionOneSelected = event.value;
    var score = this.questionAnswerList.filter(item => item.answer  === optionOneSelected);
    if (score.length > 0) {
      this.finalScore = this.finalScore + 1;
    }


  }
  optionTwo(event: MatRadioChange) {
    let optionTwoSelected = event.value;
    var score = this.questionAnswerList.filter(item => item.answer === optionTwoSelected);
    if (score.length > 0) {
      this.finalScore = this.finalScore + 1;
    }
  }
  
  optionThree(event: MatRadioChange) {
    let optionThreeSelected = event.value;
    var score = this.questionAnswerList.filter(item => item.answer === optionThreeSelected);
    if (score.length > 0) {
      this.finalScore = this.finalScore + 1;
    }
  }
  optionFour(event: MatRadioChange) {
    let optionFourSelected = event.value;
    var score = this.questionAnswerList.filter(item => item.answer === optionFourSelected);
    if (score.length > 0) {
      this.finalScore = this.finalScore + 1;
    }
  }

 
 
  getErrorMsgForUserDetasilsFormTest() {
    return this.basicOfQuestionAnswerFormGroup.controls.questionAnswers.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }


  retake()
  {
    this.basicOfQuestionAnswerFormGroup.reset();
    this.hideScore = false;
    this.hideTestDiv = true;
    this.stepper.selectedIndex = 0;  
    this.displayAnswerOnSelected();
    
  }

  moveToDrawingLearning(itemValue: string): void  {
    this.navItemSelected = itemValue;
    this.navbarService.saveActiveNavItem(this.navItemSelected);
  }



  getTestScore()
  {
    
    if ( this.basicOfQuestionAnswerFormGroup.valid) {

      let testResultsDataForm: TestResultsDataForm = new TestResultsDataForm();
      testResultsDataForm.testType = 1;
      testResultsDataForm.score = this.finalScore;
      const currentUser = localStorage.getItem('currentUser');
      testResultsDataForm.userSessionDataForm = JSON.parse(currentUser);
      this.testResultsService.saveUserTestResuts(testResultsDataForm).subscribe(
        resp => {
         
          let userData = JSON.stringify(resp);
        }, error => {
          console.log(error);
          this.snotifyService.error(error);
        })
    } else {
      this.basicOfQuestionAnswerFormGroup.markAsTouched();
      for (let inner in this.basicOfQuestionAnswerFormGroup.controls) {
        this.basicOfQuestionAnswerFormGroup.get(inner).markAsTouched();
        this.basicOfQuestionAnswerFormGroup.get(inner).updateValueAndValidity();
      }
    }
  }

  successDialogTestBasics(){
    this.getTestScore();
    this.successDialogService.successDialogForQuiz(1,this.finalScore);
    this.navbarService.saveActiveNavItem('Patent Drawing')
  }

  displayAnswerOnSelected() {
    this.finalScore = 0;
    if (this.basicOfQuestionAnswerFormGroup.valid) {
      this.hideAnswer = true;
    } else {
      this.basicOfQuestionAnswerFormGroup.markAsTouched();
      for (let inner in this.basicOfQuestionAnswerFormGroup.controls) {
        this.basicOfQuestionAnswerFormGroup.get(inner).markAsTouched();
        this.basicOfQuestionAnswerFormGroup.get(inner).updateValueAndValidity();
      }
    }
  }

}

